import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EBuildingGatesType } from '../../../packages/api-models/common/json_query';

export const selectBuildingGatesType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('building_gates_type')(jsonQuery) as EBuildingGatesType[] | null,
);
